import React from 'react'
import PropTypes from 'prop-types'
import { OEComponents } from '@opportunityeducation/oe-web-common'
import Caption1 from '../../typography/captions/Caption1'

const TimestampVersion = ({ event }) => (
  <Caption1 style={{ display: 'flex' }}>
    <OEComponents.ElapsedTimeFormatter time={event.created_at} />
    {`\u00A0• v${event.version}`}
  </Caption1>
)

TimestampVersion.propTypes = {
  event: PropTypes.object.isRequired
}

export default TimestampVersion



// WEBPACK FOOTER //
// ./src/components/quest/questhistory/TimestampVersion.js